// Section 14 arrival screen: what the player can learn about a group at the gate this season,
// one row per candidate: name, age, visible health, claimed skills (true 80% of the time) and
// whether they look sick; a tick box per row feeds "Admit some". Props only.
import type { ArrivalCandidateView, JobId, PersonId } from '../../sim/api';
import { eventsText as t } from '../text/en';

interface Props {
  candidates: readonly ArrivalCandidateView[];
  picked: readonly PersonId[];
  /** Tick boxes are shown when the prompt offers "Admit some". */
  pickable: boolean;
  disabled: boolean;
  followUp: boolean;
  jobLabel: (job: JobId) => string;
  onToggle: (personId: PersonId) => void;
}

export function ArrivalTable(props: Props) {
  const { candidates, picked, pickable, disabled, followUp, jobLabel, onToggle } = props;
  return (
    <table class="events-arrivals">
      <caption class="visually-hidden">{followUp ? t.guestsCaption : t.gateCaption}</caption>
      <thead>
        <tr>
          {pickable && <th scope="col">{t.columns.pick}</th>}
          <th scope="col">{t.columns.name}</th>
          <th scope="col" class="num">
            {t.columns.age}
          </th>
          <th scope="col" class="num">
            {t.columns.health}
          </th>
          <th scope="col">{followUp ? t.columns.skillsShown : t.columns.claims}</th>
          <th scope="col">{t.columns.sick}</th>
        </tr>
      </thead>
      <tbody>
        {candidates.map((c) => {
          const id = `arrival-pick-${c.personId}`;
          return (
            <tr key={c.personId}>
              {pickable && (
                <td>
                  <input
                    id={id}
                    type="checkbox"
                    checked={picked.includes(c.personId)}
                    disabled={disabled}
                    onChange={() => onToggle(c.personId)}
                  />
                </td>
              )}
              <th scope="row" class="name">
                {pickable ? <label for={id}>{c.name}</label> : c.name}
                {c.child && <span class="events-tag">{t.child}</span>}
              </th>
              <td class="num">{c.ageYears}</td>
              <td class="num">{c.health}</td>
              <td>
                {c.claimed.length === 0
                  ? t.noClaims
                  : c.claimed.map((s) => `${jobLabel(s.skill)} ${s.level.toFixed(1)}`).join(', ')}
              </td>
              <td>{c.looksSick ? <strong>{t.looksSick}</strong> : t.looksWell}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
